/*
 * @Author: your name
 * @Date: 2022-10-24 16:27:20
 * @LastEditTime: 2023-07-10 15:13:06
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ops-manager-frontend/src/pages/PackageManage/messages.js
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  groupServer: '所在服务器: { ip }',
  useable: '可用',
  packUsed: '安装包',
  otherUsed: '其他',
  groupDiskName: '存储空间',
  uploadTime: '上传时间',

  total: '共',
  packPosition: '安装包放置位置',
  noPackage: '无安装包',
  initPageTip: '创建运行环境需要先创建/home/supos/supos目录，请创建',
  initPageSubTip: '请进入本服务器添加, 若已完成请刷新。',
  getStatusAgain: '刷新',
  addHomeDisk: '创建目录',
  createDiskTitle: '创建安装包目录',
  sure: '确认',
  volumeGroup: '所在卷组',
  mountPoint: '挂载点',
  disk: '磁盘',
  diskTip: '未找到可用磁盘，如若已添加请刷新',
  capacity: '容量',
  capacityTip: '当前卷组没有可以分配容量,请扩容',
  refresh: '刷新',
  diskNull: '请选择磁盘',
  capacityNull: '请填写容量',
  volumeUnavailable: '当前卷组没有可分配容量,请扩容',
  capacityError: '请填写正确的值',
  maxError: '容量不能大于已选磁盘的总量',
  creating: '正在创建...',
  createSuccess: '创建成功',
  createFailed: '创建失败,请重试',
  retry: '重试',

  packageList: '安装包列表',
  fromDatabase: '从资源库获取',
  refersh: '刷新列表',
  refershSuccess: '刷新列表成功',
  refershFail: '刷新列表失败',

  initPage: '未找到安装包',

  deleteTip: '删除成功',
  deleteConfirm: '请确认删除该安装包',
  deleteRollBackConfirm: '由于该版本处于回滚版本的关键路径上，删除该包将无法回滚到如下版本：{version}。是否确认删除？',
  delete: '删除',
  deletePackage: '删除安装包',
  uploadFail: '上传文件失败，请检查网络配置，重试上传文件!',
  reset: '重试',
  cancel: '取消',
  cancelSuccess: '取消成功',
  uploading: '正在上传中......',
  cancelUploadingConfirm: '请确认取消上传',
  version: '版本号',
  fullPackage: '完整包',
  patchPackage: '补丁包',
  decompression: '解压',
  decompressioning: '正在解压中...',
  decompressionSuccess: '解压成功',
  decompressionFail: '解压失败',

  systemPack: '系统包',
  extensionPack: '扩展包',
  middlewarePack: '中间件包',
  bucketPack: '组合包',
  notCatalog: '未分类',

  year: '年',
  month: '月',
  day: '日',

  uploadApp: '上传安装包',
  existContentTip: '请确认',
  uploadRequiredModuleTitleTip: '请上传符合要求的包',
  fileCheckTip: '所选文件非supOS安装文件，或文件名称不符合要求，无法上传，请确认。',
  packRepeat: '所选安装包已存在,请勿重复上传',
  renderLost: '安装包格式不正确',
  newVg: '新卷组',
  expansion: '扩容',
});
